import type { IntlShape, MessageDescriptor } from "react-intl";

import loggingService from "@app/util/logging";

export const getDisplayName = <E extends number | string>(
  intl: IntlShape,
  messages: Record<E, MessageDescriptor>,
  enumValue: E,
  enumName: string
): string => {
  if (enumValue in messages) {
    return intl.formatMessage(messages[enumValue]);
  } else {
    const stack = new Error().stack;
    loggingService.error(`Unknown ${enumName} enum value: ${enumValue}`, { stack });
    return `${enumValue}`;
  }
};
